import { useEffect } from 'react';
import { Link } from 'react-router';
import { Drawer } from '@mgdlead/ui';

import { workspacePath } from '../workspace/navigation';
import { ChangelogList } from './ChangelogList';
import { CHANGELOG } from './changelog';

/** "Novidades" (I5): abrir já conta como visto — o ponto apaga. */
export function NewsDrawer({
  open,
  onOpenChange,
  onSeen,
  slug,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSeen: () => void;
  slug: string;
}) {
  useEffect(() => {
    if (open) onSeen();
  }, [open, onSeen]);

  return (
    <Drawer
      open={open}
      onOpenChange={onOpenChange}
      title="Novidades"
      description="O que mudou no painel, da mais nova para a mais antiga."
    >
      <ChangelogList entries={CHANGELOG.slice(0, 5)} />
      {CHANGELOG.length > 5 ? (
        <Link
          to={workspacePath(slug, 'novidades')}
          onClick={() => onOpenChange(false)}
          className="mt-6 inline-flex min-h-11 items-center text-sm font-medium text-primary underline underline-offset-2 md:min-h-0"
        >
          Ver todas as novidades
        </Link>
      ) : null}
    </Drawer>
  );
}
